import * as z from 'zod/mini';

import type { Chain } from '../../chain';
import type { HardwareWalletVendor } from '../hardwareWallet/hardwareWallet.types';
import type { WalletAddressType } from '../walletAccount';

export const unverifiedWalletAccountSchema = z.object({
  address: z.string(),
  addressesWithTypes: z.optional(
    z.array(
      z.object({
        address: z.string(),
        publicKey: z.optional(z.string()),
        type: z.custom<WalletAddressType>((val) => typeof val === 'string'),
      })
    )
  ),
  chain: z.custom<Chain>((val) => typeof val === 'string'),
  hardwareWalletVendor: z.optional(
    z.custom<HardwareWalletVendor>((val) => typeof val === 'string')
  ),
  id: z.string(),
  lastSelectedAt: z.nullable(z.date()),
  walletProviderKey: z.string(),
});
